<script lang="ts">
  import { isUserRoleADM } from "../../app.store";

  import MainMenuItem from "./MainMenuItem.svelte";

  import { PermissionService } from "../../utils/misc/permission-utils";
    import { user } from "../../app.store";


  let lead_canshow : boolean = PermissionService.isAllowedTo($user, 'lead.canshow');
  let product_canshow : boolean = PermissionService.isAllowedTo($user, 'product.canshow');
  let deal_canshow : boolean = PermissionService.isAllowedTo($user, 'deal.canshow');
  let contact_canshow : boolean = PermissionService.isAllowedTo($user, 'contact.canshow');
  let company_canshow : boolean = PermissionService.isAllowedTo($user, 'company.canshow');
  let supplier_canshow : boolean = PermissionService.isAllowedTo($user, 'company.canshow'); // per ora uguale
  let reports_canshow : boolean = PermissionService.isAllowedTo($user, 'report.canshow'); 
  let activity_canshow : boolean = PermissionService.isAllowedTo($user, 'activities.canshow'); 
 

</script>

<div class="main-menu noselect">
  <aside class="menu">
    <p class="menu-label">Funzioni</p>

    <ul class="menu-list">
      <MainMenuItem link="/dashboard" label="Cruscotto" icon="leaderboard" />      
      {#if company_canshow}
      <MainMenuItem link="/company" label="Clienti" icon="business" />
      {/if}
      {#if supplier_canshow}
      <MainMenuItem link="/supplier" label="Fornitori" icon="business" />
      {/if}
      {#if contact_canshow}
      <MainMenuItem link="/contact" label="Contatti" icon="contact_phone" />
      {/if}
      {#if lead_canshow}
      <MainMenuItem link="/lead" label="Lead" icon="account_box" />
      {/if}
      {#if activity_canshow}
      <MainMenuItem link="/task" label="Task" icon="query_builder" />
      {/if}
      {#if product_canshow}
      <MainMenuItem link="/product" label="Prodotti" icon="category" />
      {/if}
      {#if deal_canshow}
      <MainMenuItem link="/deal" label="Opportunità" icon="request_quote" />
      {/if}
      {#if company_canshow}
      <MainMenuItem link="/project" label="Progetti" icon="format_align_right" />
      {/if}

      {#if company_canshow}
      <MainMenuItem link="/invoicesemails" label="Fatture inviate" icon="mail" />
      {/if}

      {#if reports_canshow}
      <MainMenuItem link="/reports" label="Reportistica" icon="pie_chart" />
      {/if}

      {#if company_canshow}
      <MainMenuItem link="/unpaid" label="Insoluti" icon="report" />
      {/if}
      <!--
      <MainMenuItem link="/funnel" label="Funnel" icon="filter_alt" />
      <MainMenuItem link="/campaign" label="Campagne" icon="campaign" />
      <MainMenuItem
        link="/activity"
        label="Attività"
        icon="insert_invitation"
      />
      <MainMenuItem link="/ticket" label="Ticket" icon="grading" />
      <MainMenuItem link="/meeting" label="Riunioni" icon="device_hub" />
      <MainMenuItem link="/report" label="Report" icon="summarize" />
      -->
    </ul>

    {#if $isUserRoleADM}
      <p class="menu-label">Amministrazione</p>

      <ul class="menu-list">
        <MainMenuItem link="/user" label="Utenti" icon="group" />
        <!--
        <MainMenuItem link="/group" label="Gruppi" icon="groups" />
        <MainMenuItem link="/hierarchy" label="Gerarchia" icon="account_tree" />
        -->
        <MainMenuItem link="/settings" label="Impostazioni" icon="settings" />
      </ul>
    {/if}
  </aside>
</div>
